/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function CaretDownSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M0.744516 4.35016L5.40956 8.76842C5.56617 8.9167 5.77855 9 6 9C6.22145 9 6.43383 8.9167 6.59044 8.76842L11.2555 4.35016C11.3722 4.23954 11.4518 4.09862 11.484 3.94521C11.5162 3.79181 11.4996 3.6328 11.4364 3.48829C11.3732 3.34378 11.2662 3.22027 11.1289 3.13335C10.9916 3.04644 10.8302 3.00003 10.665 3H1.33495C1.16981 3.00003 1.00838 3.04644 0.871073 3.13335C0.733769 3.22027 0.626756 3.34378 0.563561 3.48829C0.500367 3.6328 0.483828 3.79181 0.516037 3.94521C0.548246 4.09862 0.627756 4.23954 0.744516 4.35016Z" fill="currentColor" />
        </svg>
    );
}
